import React, {Component} from 'react';
import { findDOMNode } from 'react-dom'
import {Modal,ButtonToolbar,Button,ControlLabel} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import AutoPartTable from './AutoPartTable'
import AutopartStore from '../../stores/AutopartStore'
import AutoPartNewItemPopup from './AutoPartNewItemPopup'
import './autopart.css';


//http://www.4wheelparts.com/buyers-guide-reviews/lift-kit-how-to-lift-kits-coilers.aspx
const SUB_CAT_34 = [
  {left:300,top:150,title:'1'},
  {left:50,top:0,title:'2'},
  {left:400,top:110,title:'2'},
  {left:200,top:0,title:'3'},
  {left:445,top:40,title:'3'},
  {left:270,top:0,title:'4'},
  {left:480,top:100,title:'4'},
  {left:310,top:20,title:'5'},
  {left:530,top:120,title:'5'},
  {left:260,top:140,title:'6'},
  {left:140,top:300,title:'7'},
  {left:305,top:400,title:'8'},
  {left:90,top:280,title:'9'},
  {left:20,top:232,title:'10'},
  {left:275,top:360,title:'11'},
  {left:355,top:400,title:'12'},
]

const SUB_CAT_910 = [
  {left:210,top:270,title:'1'},
  {left:140,top:0,title:'2'},
  {left:470,top:230,title:'2'},
  {left:390,top:15,title:'3'},
  {left:470,top:190,title:'3'},
  {left:110,top:250,title:'4'},
  {left:310,top:390,title:'4'},
  {left:80,top:45,title:'5'},
  {left:230,top:130,title:'6'},
  {left:160,top:240,title:'7'},
  {left:100,top:10,title:'8'},
]

class AutoPartViewer extends Component {
  constructor(...args){
    super(...args)
    this.state = {show:true,loading:false,itemList:[],selectedNum:'',checkedItem:[]}
  }

  componentDidMount() {
    let {subCatId} = this.props
    this.canvas = findDOMNode(this.canvasRef);
    this.ctx = this.canvas.getContext('2d');
    let canvas = this.canvas
    let ctx = this.ctx

    // this.ctx.beginPath();
    // this.ctx.ellipse(850, 400, 500, 250, 0, 0, 2 * Math.PI);
    // this.ctx.strokeStyle='#000';
    // this.ctx.lineWidth=3;
    // this.ctx.stroke();

    var img = new Image();
    if(subCatId==='34')
      img.src = 'https://demo_en.bigfix.co/304/img/suspension-1.jpg';
    else if(subCatId==='910')
      img.src = 'https://demo_en.bigfix.co/304/img/suspension-2.jpg';
    else
      img.src = 'https://demo_en.bigfix.co/304/img/no_image.jpg';
    img.onload = function () {
        ctx.drawImage(img, 0, 0, 590, 443);

    };

    let that = this
    canvas.addEventListener('click', function (e) {
        var r = canvas.getBoundingClientRect();

        var x = e.clientX - r.left;
        var y = e.clientY - r.top;

        console.log('click',x,y)
        let text = '1'
        //that.draw_text(ctx, text, x, y);
    }, false);


  }

  draw_text(context, text, x, y)
  {
      x *= 1;
      y *= 1;
      context.beginPath();
      context.arc(x, y, 10, 0, 2 * Math.PI, false);
      context.fillStyle = 'green';
      context.fill();
      context.lineWidth = 2;
      context.strokeStyle = '#003300';
      context.stroke();

      context.lineWidth = 1;
      context.fillStyle = "#FF0000";
      context.lineStyle = "#ffff00";
      context.font = "bold 22px sans-serif";
      context.fillText(text, x - 6, y + 8);


  }

  onHide(){
    this.setState({show:false})
  }

  applyCheckedItem(itemList,checkedItem){
    return itemList.map((item,index)=>{
      let checked = false
      checkedItem.map((citem,cindex)=>{
        if(citem.part_id===item.part_id){
          checked = true
        }
        return citem
      })
      item['checked'] = checked
      return item
    })
  }

  onSpotClick(number){
    console.log('onClick',number)
    let that = this
    let {checkedItem} = this.state
    let {carType,subCatId} = this.props
    this.setState({loading:true,selectedNum:number})
    AutopartStore.loadAutopart(carType,subCatId,number,function(result){
      console.log('result',result)

      that.setState({loading:false,itemList:that.applyCheckedItem(result.data,checkedItem)})
    })
  }

  onSelectClick(){
    if(typeof this.props.onApplyItem!=='undefined'){
      let {itemList,checkedItem} = this.state

      this.props.onApplyItem(checkedItem)
    }

    this.onHide()
  }

  onCancelClick(){
    this.onHide()
  }

  removeCheckedItem(checkedItem,part_id){
    return checkedItem.reduce((rresult,item)=>{
      if(item.part_id !== part_id){
          rresult.push(item)
      }
      return rresult
    },[])
  }

  onAllItemCheck(checked){
    let {itemList,checkedItem} = this.state
    itemList.map((item,index)=>{
      item['checked'] = checked
      if(checked){
        checkedItem.push(item)
      }else{
        checkedItem = this.removeCheckedItem(checkedItem,item.part_id)
      }
      return item
    })

    this.setState({itemList:itemList,checkedItem:checkedItem})
  }

  onItemCheck(index){
    let {itemList,checkedItem} = this.state
    let checked = true
    if(typeof itemList[index].checked ==='undefined')
      checked = true
    else{
      checked = !itemList[index]['checked']
    }
    //console.log('itemList',itemList)
    itemList[index]['checked'] = checked
    if(checked){
      checkedItem.push(itemList[index])
    }else{
      checkedItem = this.removeCheckedItem(checkedItem,itemList[index].part_id)
    }
    this.setState({itemList:itemList,checkedItem:checkedItem})
  }

  onSave(item){
    let {selectedNum} = this.state
    this.onSpotClick(selectedNum)
  }

  renderSpotNumber(){
    let {selectedNum} = this.state
    let {subCatId} = this.props
    let spotArray = []
    if(subCatId==='34'){
      spotArray = SUB_CAT_34
    }else if(subCatId==='910'){
      spotArray = SUB_CAT_910
    }
    return spotArray.map((item,index)=>(
      <div key={index} className={"autopart-spot-circle "+(selectedNum===item.title?'active':'')}
        style={{position:'absolute',left:item.left+'px',top:item.top+'px'}}
        onClick={this.onSpotClick.bind(this,item.title)}>
        {item.title}
      </div>
    ))
  }

  renderAutopartTable(){
    let {selectedNum,itemList} = this.state
    let {subCatId,carType} = this.props
    if(selectedNum!==''){
      return (
        <AutoPartTable itemList={itemList}
          carType={carType}
          subCatId={subCatId}
          subCatPos={selectedNum}
          onSave={this.onSave.bind(this)}
          onAllCheck={this.onAllItemCheck.bind(this)}
          onCheck={this.onItemCheck.bind(this)}/>
      )
    }else{
      if(subCatId==='34' || subCatId ==='910'){
        return (
          <div >Click on the number to show auto part item</div>
        )
      }else{
        return (
          <div >No structure diagram available on this area.</div>
        )
      }
    }
  }

  render(){
    let {show,loading} = this.state
    let label = 'Suspension Diagram'
    let width='590',height='443'

    return (
      <Modal show={show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{label}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-6'>
              <div style={{position:'relative',width:width+'px',height:height+'px',margin:'0px auto'}}>
                <canvas ref={(canvas) => { this.canvasRef = canvas; }}
                  className='autopart-canvas'
                  width={width}
                  height={height}/>
                {this.renderSpotNumber()}
              </div>
            </div>
            <div className='col-md-6'>
              <div className='box' >
                <div className='box-body'>
                  {this.renderAutopartTable()}
                </div>
                <div className="overlay" style={{display:(loading?'block':'none')}}>
                  <i className="fa fa-refresh fa-spin"></i>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='col-md-12 ' >
            <ButtonToolbar className='pull-right' >
              <Button bsStyle='primary' style={{width:'200px'}} onClick={this.onSelectClick.bind(this)}>
                <FontAwesome name='hand-o-up'/>{' '}Apply All Checked Item</Button>
              <Button style={{width:'100px'}} onClick={this.onCancelClick.bind(this)}>
                <FontAwesome name='close'/>{' '}Cancel</Button>

            </ButtonToolbar>
            <div className='pull-left' style={{lineHeight:'36px'}}>
              <ControlLabel> {this.state.errorText} </ControlLabel>
            </div>
          </div>

        </Modal.Footer>
      </Modal>
    )
  }
}

export default AutoPartViewer



// WEBPACK FOOTER //
// ./src/view/autoparts/AutoPartViewer.js